const imageSize = {
  "/andrea.webp": [400, 400],
  "/baby.webp": [365, 274],
  "/babyJessica.webp": [338, 280],
  "/chris.webp": [365, 365],
  "/driggs.webp": [400, 400],
  "/education.webp": [600, 600],
  "/employers.webp": [365, 274],
  "/esther.webp": [365, 365],
  "/eva.webp": [365, 365],
  "/family.webp": [365, 274],
  "/farhan.webp": [365, 365],
  "/flowers.webp": [365, 274],
  "/hands.webp": [365, 274],
  "/harley.webp": [365, 365],
  "/health.webp": [365, 183],
  "/ito-doctor.webp": [1000, 1000],
  "/ito-logo.png": [92, 96],
  "/jessAndDad.webp": [1280, 1280],
  "/jessDad.webp": [533, 354],
  "/jessDad2.webp": [707, 707],
  "/jessFamily.webp": [1280, 960],
  "/jessParents.webp": [1280, 1707],
  "/jessica.webp": [600, 617],
  "/jessica_ito.png": [614, 150],
  "/judith.webp": [365, 365],
  "/laptop.webp": [365, 274],
  "/larry.webp": [365, 365],
  "/licensed-certified.webp": [600, 600],
  "/life-time-support.webp": [600, 600],
  "/lois.webp": [828, 828],
  "/medicalSupplies.webp": [365, 183],
  "/medicarePlans1.webp": [365, 274],
  "/medicarePlans2.webp": [365, 274],
  "/medicarePlans3.webp": [365, 274],
  "/meeting.webp": [365, 274],
  "/nick.webp": [400, 395],
  "/office.webp": [365, 274],
  "/otherFamily.webp": [365, 274],
  "/paul.webp": [365, 365],
  "/phone.webp": [600, 600],
  "/piggy-bank.webp": [600, 600],
  "/piggyBank.webp": [365, 274],
  "/question.webp": [400, 400],
  "/richard.webp": [365, 365],
  "/roxanne.webp": [604, 604],
  "/shig.webp": [365, 365],
  "/siamak.webp": [1000, 1000],
  "/spark.webp": [400, 129],
  "/strength-in-selection.webp": [600, 600],
  "/thomas.webp": [365, 365],
  "/umbrella.webp": [365, 274],
  "/vince.webp": [365, 365],
  "/vitamins.webp": [365, 183],
  "/we-represent-you.webp": [600, 600],
  "/william.webp": [365, 364],
  "/working.webp": [365, 274],
};

const sizeFor = (src) => {
  const size = imageSize[src];
  if (!size) return {};
  return { width: size[0], height: size[1] };
};

export { imageSize, sizeFor };
